// extracted by mini-css-extract-plugin
export var box = "_8a-1";
export var checkboxRow = "_8a-8";
export var checked = "_8a-2";
export var descriptionSpacer = "_8a-a";
export var disabled = "_8a-3";
export var icon = "_8a-6";
export var input = "_8a-0";
export var labelSpacer = "_8a-9";
export var medium = "_8a-5";
export var small = "_8a-4";
export var text = "_8a-7";